<script setup>
import { computed, ref, watch } from "vue";
import { useFVStore } from "@/stores/formvibes";
import { storeToRefs } from "pinia";
import { CircleCloseFilled, Refresh, WarnTriangleFilled } from "@element-plus/icons-vue";

const props = defineProps([ 'rows', 'close','isVisible' ]);

const showDialog = ref(props.isVisible);
const store = useFVStore();

watch([() => props.isVisible],() => {
    if(props.isVisible){
        showDialog.value = true;
    }
})

const {selectedRowsId,isSaving} = storeToRefs(store);

const isData = computed(() => {
    return selectedRowsId.value.length ? true : false;
});

const deleteData = () => {
    store.deteleRows();
    closeDialog();
}

const closeDialog = () => {
    showDialog.value = false;
    props.close();
}
</script>

<template>
    <div>
        <el-dialog 
        v-model="showDialog" 
        :with-header="true"
        :show-close="true"
        @close="closeDialog"
        align-center="true"
        class="fv-sub-delete-dialog"
        width="600px"
        >
            <template #header="{ close, titleId, titleClass }">
                <div class="fv-header-title">
                    <el-icon size="20">
                        <WarnTriangleFilled />
                    </el-icon>
                    <strong>Delete Entry</strong>
                </div>
            </template>
            <div v-if="!isSaving">
                <div v-if="!isData">Please select a row to delete</div>
                <div v-if="isData">Are you sure you want to delete {{selectedRowsId.length}} {{selectedRowsId.length > 1 ? 'Entries' : 'Entry'}}?</div>
            </div>
            <div v-else>
                <el-icon size="50"><Refresh /></el-icon>
            </div>
            <template #footer="{ close, titleId, titleClass }">
                <el-button @click="closeDialog">Cancel</el-button>
                <el-button :disabled="!isData" type="danger" @click="deleteData">Delete</el-button>
            </template>
        </el-dialog>
    </div>
</template>